import React, { useState } from 'react';
import setUiMessage from '../../../Utilities/Tostify';
import { post } from '../../Auths/AuthToken';
import ReactDatePicker from 'react-datepicker';
import { DEFAULT_DATE_FORMATE } from '../../../constents';
import { ssnInputMask } from '../../../Utilities/MaskInput';

function ResponsibleParty({ data, patientId, reload }) {
  const [isEdit, setIsEdit] = useState(false);
  const [allDataEdit, setAllDataEdit] = useState(null);
  const [formValues, setFormValues] = useState([
    {
      ctm: '',
      guardian_email_id: '',
      guardian_first_name: '',
      guardian_last_name: '',
      guardian_middle_name: '',
      informant: '',
      is_finance_res_party: '',
      is_self: '',
      res_party_address1: '',
      res_party_address2: '',
      res_party_city: '',
      res_party_country: '',
      res_party_dob: '',
      res_party_external_id: '',
      res_party_gender: '',
      res_party_home_phone: '',
      res_party_mobile: '',
      res_party_relationship: '',
      res_party_ssn: '',
      res_party_state: '',
      res_party_work_phone: '',
      res_party_zip: '',
      responsible_party_id: '',
      addToMaster: '',
      party_status: '',
    },
  ]);

  const getResPartyData = async (id, i) => {
    try {
      const response = await post('api/patient/Patient/resposibalPartyData', {
        responsible_party_id: id,
        patient_id: patientId,
      });
      if (response?.status === 200) {
        const sourceData = response?.data;
        setFormValues((ele) => {
          const sel = [...ele];
          sel[i] = {
            //id: sourceData.id,
            ctm: sourceData.ctm,
            guardian_email_id: sourceData.email_id,
            guardian_first_name: sourceData.first_name,
            guardian_last_name: sourceData.last_name,
            guardian_middle_name: sourceData.middle_name,
            informant: sourceData.informant,
            is_finance_res_party: sourceData.is_finance_res_party,
            is_self: sourceData.is_self,
            res_party_address1: sourceData.address_1,
            res_party_address2: sourceData.address_2,
            res_party_city: sourceData.city,
            res_party_country: sourceData.country,
            res_party_dob: sourceData.date_of_birth,
            res_party_external_id: sourceData.external_id,
            res_party_gender: sourceData.gender,
            res_party_home_phone: sourceData.home_phone,
            res_party_mobile: sourceData.mobile,
            res_party_relationship: sourceData.relationship,
            res_party_ssn: sourceData.ssn,
            res_party_state: sourceData.state,
            res_party_work_phone: sourceData.work_phone,
            res_party_zip: sourceData.zip,
            responsible_party_id: sourceData.id,
          };
          return sel;
        });
      }
    } catch (e) {
      setUiMessage('err', e.message);
    }
  };

  const handleResPartyChange = async () => {
    setIsEdit(true);
    try {
      const response = await post('api/patient/Patient/editPatientProfile', {
        patientId: patientId,
      });
      if (response?.status === 200) {
        setAllDataEdit(response?.data);
        const patientDetails = response?.data?.patientResponsibleData;
        setFormValues(patientDetails);
      }
    } catch (e) {
      setUiMessage('err', e.message);
    }
  };

  const handleFieldChange = ({ target: { id, value } }, i) => {
    if (id === 'res_party_ssn') {
      setFormValues((ele) => {
        const sel = [...ele];
        sel[i] = { ...ele[i], res_party_ssn: ssnInputMask(value) };
        return sel;
      });
    } else if (id === 'responsible_party_id') {
      getResPartyData(value, i);
      setFormValues((ele) => {
        const sel = [...ele];
        sel[i] = { ...ele[i], [id]: value };
        return sel;
      });
    } else {
      setFormValues((ele) => {
        const sel = [...ele];
        sel[i] = { ...ele[i], [id]: value };
        return sel;
      });
    }
  };

  const setPatDob = (dob, i) => {
    setFormValues((ele) => {
      const sel = [...ele];
      sel[i] = { ...ele[i], res_party_dob: dob };
      return sel;
    });
  };

  const handleSave = async () => {
    setIsEdit(false);

    try {
      const response = await post('api/patient/Patient/updatePatient', {
        updateInfo: 'Guardian-Information',
        patient_id: patientId,
        addToMaster: formValues.map((obj) => 0).join(','),
        allCtm: formValues.map((obj) => obj?.ctm).join(','),
        allInformant: formValues.map((obj) => obj?.informant).join(','),
        isFinanceParty: formValues
          .map((obj) => obj?.is_finance_res_party)
          .join(','),
        party_status: formValues.map((obj) =>
          obj?.id ? 'old_' + obj?.id : 'new'
        ),
        responsible_party_id: formValues.map((obj) =>
          parseInt(obj?.responsible_party_id) === 0
            ? 'Self'
            : obj?.responsible_party_id
        ),
        guardian_first_name: formValues.map((obj) => obj?.guardian_first_name),
        guardian_middle_name: formValues.map(
          (obj) => obj?.guardian_middle_name
        ),
        guardian_last_name: formValues.map((obj) => obj?.guardian_last_name),
        res_party_dob: formValues.map((obj) => obj?.res_party_dob),
        res_party_gender: formValues.map((obj) => obj?.res_party_gender),
        guardian_email_id: formValues.map((obj) => obj?.guardian_email_id),
        res_party_ssn: formValues.map((obj) => obj?.res_party_ssn),
        res_party_relationship: formValues.map(
          (obj) => obj?.res_party_relationship
        ),
        addUpdateIntoMaster: formValues.map((obj) => 0),
        is_finance_res_party: formValues.map(
          (obj) => obj?.is_finance_res_party
        ),
        res_party_external_id: formValues.map(
          (obj) => obj?.res_party_external_id
        ),
        res_party_home_phone: formValues.map(
          (obj) => obj?.res_party_home_phone
        ),
        res_party_work_phone: formValues.map(
          (obj) => obj?.res_party_work_phone
        ),
        res_party_mobile: formValues.map((obj) => obj?.res_party_mobile),
        res_party_address1: formValues.map((obj) => obj?.res_party_address1),
        res_party_address2: formValues.map((obj) => obj?.res_party_address2),
        res_party_zip: formValues.map((obj) => obj?.res_party_zip),
        res_party_city: formValues.map((obj) => obj?.res_party_city),
        res_party_state: formValues.map((obj) => obj?.res_party_state),
        res_party_country: formValues.map((obj) => obj?.res_party_country),
        loginUserId: '2',
      });
      if (response?.status === 200) {
        reload();
      }
    } catch (e) {
      setUiMessage('err', e.message);
    }
  };
  return (
    <>
      {isEdit ? (
        <div className="demo-main-con-sec">
          <div className="demo-main-con-chld-hdr">
            <div className="chld-hdr-hdng" style={{ width: '85%' }}>
              Responsible Party:
            </div>
            <div className="chld-hdr-edt">
              <span className="demo-edt-icn">
                <div className="actn-No" onClick={() => setIsEdit(false)}>
                  Cancel
                </div>
                <div className="actn-yes" onClick={handleSave}>
                  Save
                </div>
              </span>
            </div>
          </div>
          {formValues &&
            formValues.map((item, i) => {
              return (
                <div
                  key={i}
                  className="demo-main-con-chld-bdy"
                  style={{ marginBottom: '10px' }}
                >
                  <div className="flex-sec alt-rw">
                    <div className="demo-main-con-chld-bdy-rw">
                      <span className="nsu-act-lbl">Responsible Party:</span>
                      <span className="nsu-act-val">
                        <select
                          className="inpt-width-nw"
                          id="responsible_party_id"
                          value={item?.responsible_party_id || ''}
                          onChange={(e) => handleFieldChange(e, i)}
                        >
                          <option value="Self">Self</option>
                          {allDataEdit?.respPartyList &&
                            allDataEdit?.respPartyList.map((item, i) => {
                              return (
                                <option key={i} value={item?.id}>
                                  {item?.full_name}
                                </option>
                              );
                            })}
                        </select>
                      </span>
                    </div>
                    <div className="demo-main-con-chld-bdy-rw">
                      <span className="nsu-act-lbl">SSN:</span>
                      <span className="nsu-act-val">
                        <input
                          type="text"
                          className="inpt-width-nw"
                          placeholder=""
                          id="res_party_ssn"
                          value={item?.res_party_ssn || ''}
                          onChange={(e) => handleFieldChange(e, i)}
                          maxLength="11"
                        />
                      </span>
                    </div>
                    <div className="demo-main-con-chld-bdy-rw">
                      <span className="nsu-act-lbl">Address1:</span>
                      <span className="nsu-act-val">
                        <input
                          type="text"
                          className="inpt-width-nw"
                          placeholder=""
                          id="res_party_address1"
                          value={item?.res_party_address1 || ''}
                          onChange={(e) => handleFieldChange(e, i)}
                        />
                      </span>
                    </div>
                  </div>
                  <div className="flex-sec">
                    <div className="demo-main-con-chld-bdy-rw">
                      <span className="nsu-act-lbl">First Name:</span>
                      <span className="nsu-act-val">
                        <input
                          type="text"
                          className="inpt-width-nw"
                          placeholder=""
                          id="guardian_first_name"
                          value={item?.guardian_first_name || ''}
                          onChange={(e) => handleFieldChange(e, i)}
                        />
                      </span>
                    </div>
                    <div className="demo-main-con-chld-bdy-rw">
                      <span className="nsu-act-lbl">Home Phone:</span>
                      <span className="nsu-act-val">
                        <input
                          type="text"
                          className="inpt-width-nw"
                          placeholder=""
                          id="res_party_home_phone"
                          value={item?.res_party_home_phone || ''}
                          onChange={(e) => handleFieldChange(e, i)}
                          maxLength="10"
                        />
                      </span>
                    </div>
                    <div className="demo-main-con-chld-bdy-rw">
                      <span className="nsu-act-lbl">Address2:</span>
                      <span className="nsu-act-val">
                        <input
                          type="text"
                          className="inpt-width-nw"
                          placeholder=""
                          id="res_party_address2"
                          value={item?.res_party_address2 || ''}
                          onChange={(e) => handleFieldChange(e, i)}
                        />
                      </span>
                    </div>
                  </div>
                  <div className="flex-sec alt-rw">
                    <div className="demo-main-con-chld-bdy-rw">
                      <span className="nsu-act-lbl">Middle Name:</span>
                      <span className="nsu-act-val">
                        <input
                          type="text"
                          className="inpt-width-nw"
                          placeholder=""
                          id="guardian_middle_name"
                          value={item?.guardian_middle_name || ''}
                          onChange={(e) => handleFieldChange(e, i)}
                        />
                      </span>
                    </div>
                    <div className="demo-main-con-chld-bdy-rw">
                      <span className="nsu-act-lbl">Mobile Phone:</span>
                      <span className="nsu-act-val">
                        <input
                          type="text"
                          className="inpt-width-nw"
                          placeholder=""
                          id="res_party_mobile"
                          value={item?.res_party_mobile || ''}
                          onChange={(e) => handleFieldChange(e, i)}
                          maxLength="10"
                        />
                      </span>
                    </div>
                    <div className="demo-main-con-chld-bdy-rw">
                      <span className="nsu-act-lbl">City:</span>
                      <span className="nsu-act-val">
                        <input
                          type="text"
                          className="inpt-width-nw"
                          placeholder=""
                          id="res_party_city"
                          value={item?.res_party_city || ''}
                          onChange={(e) => handleFieldChange(e, i)}
                        />
                      </span>
                    </div>
                  </div>
                  <div className="flex-sec">
                    <div className="demo-main-con-chld-bdy-rw">
                      <span className="nsu-act-lbl">Last Name:</span>
                      <span className="nsu-act-val">
                        <input
                          type="text"
                          className="inpt-width-nw"
                          placeholder=""
                          id="guardian_last_name"
                          value={item?.guardian_last_name || ''}
                          onChange={(e) => handleFieldChange(e, i)}
                        />
                      </span>
                    </div>
                    <div className="demo-main-con-chld-bdy-rw">
                      <span className="nsu-act-lbl">Work Phone:</span>
                      <span className="nsu-act-val">
                        <input
                          type="text"
                          className="inpt-width-nw"
                          placeholder=""
                          id="res_party_work_phone"
                          value={item?.res_party_work_phone || ''}
                          onChange={(e) => handleFieldChange(e, i)}
                          maxLength="10"
                        />
                      </span>
                    </div>
                    <div className="demo-main-con-chld-bdy-rw">
                      <span className="nsu-act-lbl">Zip:</span>
                      <span className="nsu-act-val">
                        <input
                          type="text"
                          className="inpt-width-nw"
                          placeholder=""
                          id="res_party_zip"
                          value={item?.res_party_zip || ''}
                          onChange={(e) => handleFieldChange(e, i)}
                          maxLength="5"
                        />
                      </span>
                    </div>
                  </div>
                  <div className="flex-sec alt-rw">
                    <div className="demo-main-con-chld-bdy-rw">
                      <span className="nsu-act-lbl">DOB:</span>
                      <span className="nsu-act-val">
                        <ReactDatePicker
                          selected={
                            item?.res_party_dob &&
                            item?.res_party_dob !== '0000-00-00'
                              ? new Date(item.res_party_dob)
                              : null
                          }
                          onChange={(date) => setPatDob(date, i)}
                          className="inpt-width-nw"
                          dateFormat={DEFAULT_DATE_FORMATE}
                          showMonthDropdown
                          showYearDropdown
                          dropdownMode="select"
                        />
                      </span>
                    </div>
                    <div className="demo-main-con-chld-bdy-rw">
                      <span className="nsu-act-lbl">Informant:</span>
                      <span className="nsu-act-val">
                        <select
                          className="inpt-width-nw"
                          id="informant"
                          value={item.informant || ''}
                          onChange={(e) => handleFieldChange(e, i)}
                        >
                          <option value="0">No</option>
                          <option value="1">Yes</option>
                        </select>
                      </span>
                    </div>
                    <div className="demo-main-con-chld-bdy-rw">
                      <span className="nsu-act-lbl">State:</span>
                      <span className="nsu-act-val">
                        <select
                          className="inpt-width-nw"
                          id="res_party_state"
                          value={item?.res_party_state || ''}
                          onChange={(e) => handleFieldChange(e, i)}
                        >
                          <option value="">Select</option>
                          {allDataEdit?.contactDetailArr?.stateList &&
                            allDataEdit?.contactDetailArr?.stateList.map(
                              (item, i) => {
                                return (
                                  <option key={i} value={item?.id}>
                                    {item?.iso_code}
                                  </option>
                                );
                              }
                            )}
                        </select>
                      </span>
                    </div>
                  </div>
                  <div className="flex-sec">
                    <div className="demo-main-con-chld-bdy-rw">
                      <span className="nsu-act-lbl">Sex:</span>
                      <span className="nsu-act-val">
                        <select
                          className="inpt-width-nw"
                          id="res_party_gender"
                          value={item?.res_party_gender || ''}
                          onChange={(e) => handleFieldChange(e, i)}
                        >
                          <option value="">Select</option>
                          {allDataEdit?.identityDetailArr?.sex &&
                            allDataEdit?.identityDetailArr?.sex.map(
                              (item, i) => {
                                return (
                                  <option key={i} value={item?.id}>
                                    {item?.val}
                                  </option>
                                );
                              }
                            )}
                        </select>
                      </span>
                    </div>
                    <div className="demo-main-con-chld-bdy-rw">
                      <span className="nsu-act-lbl">Care of team member:</span>
                      <span className="nsu-act-val">
                        <select
                          className="inpt-width-nw"
                          id="ctm"
                          value={item?.ctm || ''}
                          onChange={(e) => handleFieldChange(e, i)}
                        >
                          <option value="0">No</option>
                          <option value="1">Yes</option>
                        </select>
                      </span>
                    </div>
                    <div className="demo-main-con-chld-bdy-rw">
                      <span className="nsu-act-lbl">Country:</span>
                      <span className="nsu-act-val">
                        <select
                          className="inpt-width-nw"
                          id="res_party_country"
                          value={item?.res_party_country || ''}
                          onChange={(e) => handleFieldChange(e, i)}
                        >
                          <option value="">Select</option>
                          {allDataEdit?.contactDetailArr?.countryList &&
                            allDataEdit?.contactDetailArr?.countryList.map(
                              (item, i) => {
                                return (
                                  <option key={i} value={item?.id}>
                                    {item?.country_name}
                                  </option>
                                );
                              }
                            )}
                        </select>
                      </span>
                    </div>
                  </div>
                  <div className="flex-sec alt-rw">
                    <div className="demo-main-con-chld-bdy-rw">
                      <span className="nsu-act-lbl">Email ID:</span>
                      <span className="nsu-act-val">
                        <input
                          type="text"
                          className="inpt-width-nw"
                          placeholder=""
                          id="guardian_email_id"
                          value={item?.guardian_email_id || ''}
                          onChange={(e) => handleFieldChange(e, i)}
                        />
                      </span>
                    </div>
                    <div className="demo-main-con-chld-bdy-rw">
                      <span className="nsu-act-lbl">External ID:</span>
                      <span className="nsu-act-val">
                        <input
                          type="text"
                          className="inpt-width-nw"
                          placeholder="Write external ID here.."
                          id="res_party_external_id"
                          value={item?.res_party_external_id || ''}
                          onChange={(e) => handleFieldChange(e, i)}
                        />
                      </span>
                    </div>
                    <div className="demo-main-con-chld-bdy-rw">
                      <span className="nsu-act-lbl">
                        Financial Responsible Party:
                      </span>
                      <span className="nsu-act-val">
                        <select
                          className="inpt-width-nw"
                          id="is_finance_res_party"
                          value={item?.is_finance_res_party || ''}
                          onChange={(e) => handleFieldChange(e, i)}
                        >
                          <option value="0">No</option>
                          <option value="1">Yes</option>
                        </select>
                      </span>
                    </div>
                  </div>
                  <div className="flex-sec alt-rw">
                    <div className="demo-main-con-chld-bdy-rw">
                      <span className="nsu-act-lbl">Relationship:</span>
                      <span className="nsu-act-val">
                        <select
                          className="inpt-width-nw"
                          id="res_party_relationship"
                          value={item?.res_party_relationship || ''}
                          onChange={(e) => handleFieldChange(e, i)}
                        >
                          <option value="">Select</option>
                          {allDataEdit?.emergencyContactDetailArr
                            ?.relationship &&
                            allDataEdit?.emergencyContactDetailArr?.relationship.map(
                              (item, i) => {
                                return (
                                  <option key={i} value={item?.id}>
                                    {item?.title}
                                  </option>
                                );
                              }
                            )}
                        </select>
                      </span>
                    </div>
                    <div className="demo-main-con-chld-bdy-rw">
                      <span className="nsu-act-lbl">{''}</span>
                      <span className="nsu-act-val">{''}</span>
                    </div>
                    <div className="demo-main-con-chld-bdy-rw">
                      <span className="nsu-act-lbl">{''}</span>
                      <span className="nsu-act-val">{''}</span>
                    </div>
                  </div>
                </div>
              );
            })}
        </div>
      ) : (
        <div className="demo-main-con-sec">
          <div className="demo-main-con-chld-hdr">
            <div className="chld-hdr-hdng">Responsible Party:</div>
            <div className="chld-hdr-edt">
              <span className="demo-edt-icn" onClick={handleResPartyChange}>
                &#9998;
              </span>
            </div>
          </div>
          {data &&
            data.map((item, i) => {
              return (
                <div
                  key={i}
                  className="demo-main-con-chld-bdy"
                  style={{ marginTop: '10px' }}
                >
                  <div className="flex-sec alt-rw">
                    <div className="demo-main-con-chld-bdy-rw">
                      <span className="nsu-act-lbl">Responsible Party:</span>
                      <span className="nsu-act-val">
                        {item?.responsiblePartyName
                          ? item?.responsiblePartyName
                          : 'self'}
                      </span>
                    </div>
                    <div className="demo-main-con-chld-bdy-rw">
                      <span className="nsu-act-lbl">SSN:</span>
                      <span className="nsu-act-val">{item?.ssn}</span>
                    </div>
                    <div className="demo-main-con-chld-bdy-rw">
                      <span className="nsu-act-lbl">Address1:</span>
                      <span className="nsu-act-val">{item?.address1}</span>
                    </div>
                  </div>
                  <div className="flex-sec">
                    <div className="demo-main-con-chld-bdy-rw">
                      <span className="nsu-act-lbl">First Name:</span>
                      <span className="nsu-act-val">
                        {item?.guardian_f_name}
                      </span>
                    </div>
                    <div className="demo-main-con-chld-bdy-rw">
                      <span className="nsu-act-lbl">Home Phone:</span>
                      <span className="nsu-act-val">{item?.home_phone}</span>
                    </div>
                    <div className="demo-main-con-chld-bdy-rw">
                      <span className="nsu-act-lbl">Address2:</span>
                      <span className="nsu-act-val">{item?.address2}</span>
                    </div>
                  </div>
                  <div className="flex-sec alt-rw">
                    <div className="demo-main-con-chld-bdy-rw">
                      <span className="nsu-act-lbl">Middle Name:</span>
                      <span className="nsu-act-val">
                        {item?.guardian_m_name}
                      </span>
                    </div>
                    <div className="demo-main-con-chld-bdy-rw">
                      <span className="nsu-act-lbl">Mobile Phone:</span>
                      <span className="nsu-act-val">{item?.mobile}</span>
                    </div>
                    <div className="demo-main-con-chld-bdy-rw">
                      <span className="nsu-act-lbl">City:</span>
                      <span className="nsu-act-val">{item?.city}</span>
                    </div>
                  </div>
                  <div className="flex-sec">
                    <div className="demo-main-con-chld-bdy-rw">
                      <span className="nsu-act-lbl">Last Name:</span>
                      <span className="nsu-act-val">
                        {item?.guardian_l_name}
                      </span>
                    </div>
                    <div className="demo-main-con-chld-bdy-rw">
                      <span className="nsu-act-lbl">Work Phone:</span>
                      <span className="nsu-act-val">{item?.work_phone}</span>
                    </div>
                    <div className="demo-main-con-chld-bdy-rw">
                      <span className="nsu-act-lbl">Zip:</span>
                      <span className="nsu-act-val">{item?.zip}</span>
                    </div>
                  </div>
                  <div className="flex-sec alt-rw">
                    <div className="demo-main-con-chld-bdy-rw">
                      <span className="nsu-act-lbl">DOB:</span>
                      <span className="nsu-act-val">{item?.dob}</span>
                    </div>
                    <div className="demo-main-con-chld-bdy-rw">
                      <span className="nsu-act-lbl">Informant:</span>
                      <span className="nsu-act-val">{item?.informent}</span>
                    </div>
                    <div className="demo-main-con-chld-bdy-rw">
                      <span className="nsu-act-lbl">State:</span>
                      <span className="nsu-act-val">{item?.state}</span>
                    </div>
                  </div>
                  <div className="flex-sec">
                    <div className="demo-main-con-chld-bdy-rw">
                      <span className="nsu-act-lbl">Sex:</span>
                      <span className="nsu-act-val">{item?.sex}</span>
                    </div>
                    <div className="demo-main-con-chld-bdy-rw">
                      <span className="nsu-act-lbl">Care of team member:</span>
                      <span className="nsu-act-val">
                        {item?.careOfTeamMember}
                      </span>
                    </div>
                    <div className="demo-main-con-chld-bdy-rw">
                      <span className="nsu-act-lbl">Country:</span>
                      <span className="nsu-act-val">{item?.country}</span>
                    </div>
                  </div>
                  <div className="flex-sec alt-rw">
                    <div className="demo-main-con-chld-bdy-rw">
                      <span className="nsu-act-lbl">Email ID:</span>
                      <span className="nsu-act-val">{item?.email}</span>
                    </div>
                    <div className="demo-main-con-chld-bdy-rw">
                      <span className="nsu-act-lbl">External ID:</span>
                      <span className="nsu-act-val">{item?.external_id}</span>
                    </div>
                    <div className="demo-main-con-chld-bdy-rw">
                      <span className="nsu-act-lbl">
                        Financial Responsible Party:
                      </span>
                      <span className="nsu-act-val">{item?.finResParty}</span>
                    </div>
                  </div>
                  <div className="flex-sec alt-rw">
                    <div className="demo-main-con-chld-bdy-rw">
                      <span className="nsu-act-lbl">Responsible Party:</span>
                      <span className="nsu-act-val">{item?.relationship}</span>
                    </div>
                    <div className="demo-main-con-chld-bdy-rw">
                      <span className="nsu-act-lbl"></span>
                      <span className="nsu-act-val"></span>
                    </div>
                    <div className="demo-main-con-chld-bdy-rw">
                      <span className="nsu-act-lbl"></span>
                      <span className="nsu-act-val"></span>
                    </div>
                  </div>
                </div>
              );
            })}
        </div>
      )}
    </>
  );
}

export default ResponsibleParty;
